import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, vModelRadio as _vModelRadio, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers } from "vue";
const _hoisted_1 = { class: "footerFixed" };
const _hoisted_2 = {
    id: "all_wrapper",
    class: "mentor_add_entry"
};
const _hoisted_3 = { class: "wrapper_1" };
const _hoisted_4 = { class: "inner" };
const _hoisted_5 = { class: "normal" };
const _hoisted_6 = {
    key: 0,
    class: "err"
};
const _hoisted_7 = {
    key: 0,
    class: "err"
};
const _hoisted_8 = {
    key: 1,
    class: "err"
};
const _hoisted_9 = {
    key: 2,
    class: "err"
};
const _hoisted_10 = {
    key: 3,
    class: "err"
};
const _hoisted_11 = ["value"];
const _hoisted_12 = ["value"];
const _hoisted_13 = {
    key: 4,
    class: "err"
};
const _hoisted_14 = {
    key: 5,
    class: "err"
};
const _hoisted_15 = {
    key: 6,
    class: "err"
};
const _hoisted_16 = { class: "bt_box" };
const _hoisted_17 = { class: "err_list" };
const _hoisted_18 = {
    key: 0,
    class: "modal",
    id: "success-modal"
};
import { watch, onUnmounted, ref, computed } from 'vue';
import { Inertia } from '@inertiajs/inertia';
import headerVue from '@layout/header.vue';
import footerVue from '@layout/footer.vue';
import Alert from '@util/BrowserAlert';
import PageExitConfirm from '@util/PageExitConfirm';
import InertiaUtil from '@util/InertiaUtil';
import { AccountType } from '@util/Consts';
export default /*@__PURE__*/ _defineComponent({
    __name: 'mentor_add_entry',
    props: {
        common: {},
        errors: {}
    },
    setup(__props) {
        const props = __props;
        const form = InertiaUtil.getForm({
            // receive_rewards: true,
            bank_code: '',
            institution_name: '',
            branch_code: '',
            branch_name: '',
            account_type: AccountType.USUALLY,
            account_holder: '',
            account_number: '',
            is_professional: null,
        });
        // モーダル表示用の状態管理
        const showSuccessModal = ref(false);
        // エラーメッセージの順序を制御（源泉徴収を最上段に）
        const orderedErrors = computed(() => {
            if (!props.errors)
                return [];
            const result = [];
            // 源泉徴収を最初に
            if (props.errors.is_professional) {
                result.push(props.errors.is_professional);
            }
            // その他のエラーを追加
            for (const key in props.errors) {
                if (key !== 'is_professional') {
                    result.push(props.errors[key]);
                }
            }
            return result;
        });
        watch(() => form.bank_code, () => {
            const pattern = /[^0-9]/g;
            form.bank_code = form.bank_code.replace(pattern, '');
        });
        watch(() => form.branch_code, () => {
            const pattern = /[^0-9]/g;
            form.branch_code = form.branch_code.replace(pattern, '');
        });
        watch(() => form.account_number, () => {
            const pattern = /[^0-9]/g;
            form.account_number = form.account_number.replace(pattern, '');
        });
        // 文字数チェック
        watch(() => form.institution_name, (value) => {
            if (Alert.charLimitText(value)) {
                form.institution_name = value.substring(0, Alert.TEXT_LIMIT_NUMBER);
            }
        });
        watch(() => form.branch_name, (value) => {
            if (Alert.charLimitText(value)) {
                form.branch_name = value.substring(0, Alert.TEXT_LIMIT_NUMBER);
            }
        });
        watch(() => form.account_holder, (value) => {
            if (Alert.charLimitText(value)) {
                form.account_holder = value.substring(0, Alert.TEXT_LIMIT_NUMBER);
            }
        });
        watch(() => form.account_number, (value) => {
            if (Alert.charLimitText(value)) {
                form.account_number = value.substring(0, Alert.TEXT_LIMIT_NUMBER);
            }
        });
        // 編集チェック
        watch(() => form, () => PageExitConfirm.addEvent(), { deep: true });
        const onSubmit = () => {
            PageExitConfirm.removeEvent();
            InertiaUtil.post(form, route('mentor.register.additional.store'), () => {
                // 成功時のコールバック
                if (Object.keys(props.errors).length === 0) {
                    showSuccessModal.value = true;
                }
            });
        };
        const onCloseModal = () => {
            showSuccessModal.value = false;
            // モーダルを閉じた後にメンターホームにリダイレクト
            Inertia.get(route('question.index'));
        };
        onUnmounted(() => {
            PageExitConfirm.removeEvent();
        });
        return (_ctx, _cache) => {
            var _a, _b, _c, _d, _e, _f, _g, _h;
            return (_openBlock(), _createElementBlock("div", null, [
                _createVNode(headerVue, {
                    common: props.common
                }, null, 8, ["common"]),
                _createElementVNode("div", _hoisted_1, [
                    _createElementVNode("div", _hoisted_2, [
                        _createElementVNode("div", _hoisted_3, [
                            _cache[41] || (_cache[41] = _createElementVNode("h2", null, "メンター追加情報登録", -1)),
                            _createElementVNode("div", _hoisted_4, [
                                _cache[40] || (_cache[40] = _createElementVNode("p", null, [
                                    _createTextVNode("メンター審査にて承認されたため、追加情報の登録をお願い致します。"),
                                    _createElementVNode("br"),
                                    _createTextVNode("後でメニューから変更することもできます。")
                                ], -1)),
                                _createElementVNode("form", {
                                    onSubmit: _withModifiers(onSubmit, ["prevent"])
                                }, [
                                    _createElementVNode("dl", _hoisted_5, [
                                        _cache[37] || (_cache[37] = _createElementVNode("dt", { class: "must" }, [
                                            _createTextVNode(" 源泉徴収"),
                                            _createElementVNode("br", { class: "pc" }),
                                            _createElementVNode("span", { class: "must" }, "必須"),
                                            _createElementVNode("span", { class: "non_public" }, "非公開")
                                        ], -1)),
                                        _createElementVNode("dd", null, [
                                            _cache[10] || (_cache[10] = _createElementVNode("p", { class: "sub_t" }, "源泉徴収対象者ですか？", -1)),
                                            _cache[11] || (_cache[11] = _createElementVNode("span", null, [
                                                _createTextVNode("(弁護士、税理士、社会保険労務士等の士業の方。"),
                                                _createElementVNode("br"),
                                                _createTextVNode("対象者の場合、報酬から源泉所得税額を差し引いたうえでお振込します。)")
                                            ], -1)),
                                            _cache[12] || (_cache[12] = _createElementVNode("br", null, null, -1)),
                                            _withDirectives(_createElementVNode("input", {
                                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_unref(form).is_professional) = $event)),
                                                value: 1,
                                                class: "visually-hidden",
                                                type: "radio",
                                                name: "q3_1",
                                                id: "q3_1_a1"
                                            }, null, 512), [
                                                [_vModelRadio, _unref(form).is_professional]
                                            ]),
                                            _cache[13] || (_cache[13] = _createElementVNode("label", { for: "q3_1_a1" }, "はい", -1)),
                                            _withDirectives(_createElementVNode("input", {
                                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((_unref(form).is_professional) = $event)),
                                                value: 0,
                                                class: "visually-hidden",
                                                type: "radio",
                                                name: "q3_1",
                                                id: "q3_1_a2"
                                            }, null, 512), [
                                                [_vModelRadio, _unref(form).is_professional]
                                            ]),
                                            _cache[14] || (_cache[14] = _createElementVNode("label", { for: "q3_1_a2" }, "いいえ", -1)),
                                            _cache[15] || (_cache[15] = _createElementVNode("br", null, null, -1)),
                                            ((_a = props.errors) === null || _a === void 0 ? void 0 : _a.is_professional)
                                                ? (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString(props.errors.is_professional), 1))
                                                : _createCommentVNode("", true)
                                        ]),
                                        _cache[38] || (_cache[38] = _createElementVNode("dt", { class: "must" }, [
                                            _createTextVNode(" 振込先"),
                                            _createElementVNode("br", { class: "pc" }),
                                            _createElementVNode("span", { class: "must" }, "必須"),
                                            _createElementVNode("span", { class: "non_public" }, "非公開")
                                        ], -1)),
                                        _createElementVNode("dd", null, [
                                            _cache[16] || (_cache[16] = _createElementVNode("p", { class: "sub_t" }, "金融機関コード", -1)),
                                            _withDirectives(_createElementVNode("input", {
                                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_unref(form).bank_code) = $event)),
                                                type: "text",
                                                name: "q2_1",
                                                class: "w20 inquiry-form",
                                                maxlength: "4"
                                            }, null, 512), [
                                                [_vModelText, _unref(form).bank_code]
                                            ]),
                                            _cache[17] || (_cache[17] = _createElementVNode("span", null, "（半角数字4桁）", -1)),
                                            _cache[18] || (_cache[18] = _createElementVNode("br", null, null, -1)),
                                            ((_b = props.errors) === null || _b === void 0 ? void 0 : _b.bank_code)
                                                ? (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(props.errors.bank_code), 1))
                                                : _createCommentVNode("", true),
                                            _cache[19] || (_cache[19] = _createElementVNode("p", { class: "sub_t" }, "金融機関名", -1)),
                                            _withDirectives(_createElementVNode("input", {
                                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((_unref(form).institution_name) = $event)),
                                                type: "text",
                                                name: "q2_2",
                                                class: "w60 inquiry-form",
                                                placeholder: "例：みずほ銀行"
                                            }, null, 512), [
                                                [_vModelText, _unref(form).institution_name]
                                            ]),
                                            _cache[20] || (_cache[20] = _createElementVNode("br", null, null, -1)),
                                            ((_c = props.errors) === null || _c === void 0 ? void 0 : _c.institution_name)
                                                ? (_openBlock(), _createElementBlock("p", _hoisted_8, _toDisplayString(props.errors.institution_name), 1))
                                                : _createCommentVNode("", true),
                                            _cache[21] || (_cache[21] = _createElementVNode("p", { class: "sub_t" }, "支店コード", -1)),
                                            _withDirectives(_createElementVNode("input", {
                                                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((_unref(form).branch_code) = $event)),
                                                type: "text",
                                                name: "q2_3",
                                                class: "w20 inquiry-form",
                                                maxlength: "3"
                                            }, null, 512), [
                                                [_vModelText, _unref(form).branch_code]
                                            ]),
                                            _cache[22] || (_cache[22] = _createElementVNode("span", null, "（半角数字3桁）", -1)),
                                            _cache[23] || (_cache[23] = _createElementVNode("br", null, null, -1)),
                                            ((_d = props.errors) === null || _d === void 0 ? void 0 : _d.branch_code)
                                                ? (_openBlock(), _createElementBlock("p", _hoisted_9, _toDisplayString(props.errors.branch_code), 1))
                                                : _createCommentVNode("", true),
                                            _cache[24] || (_cache[24] = _createElementVNode("p", { class: "sub_t" }, "支店名", -1)),
                                            _withDirectives(_createElementVNode("input", {
                                                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((_unref(form).branch_name) = $event)),
                                                type: "text",
                                                name: "q2_4",
                                                class: "f_corp wmax inquiry-form",
                                                placeholder: "例：品川支店"
                                            }, null, 512), [
                                                [_vModelText, _unref(form).branch_name]
                                            ]),
                                            _cache[25] || (_cache[25] = _createElementVNode("br", null, null, -1)),
                                            ((_e = props.errors) === null || _e === void 0 ? void 0 : _e.branch_name)
                                                ? (_openBlock(), _createElementBlock("p", _hoisted_10, _toDisplayString(props.errors.branch_name), 1))
                                                : _createCommentVNode("", true),
                                            _cache[26] || (_cache[26] = _createElementVNode("p", { class: "sub_t" }, "種別", -1)),
                                            _withDirectives(_createElementVNode("input", {
                                                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((_unref(form).account_type) = $event)),
                                                value: _unref(AccountType).USUALLY,
                                                class: "visually-hidden",
                                                type: "radio",
                                                name: "q2_5",
                                                id: "q2_5_a1"
                                            }, null, 8, _hoisted_11), [
                                                [_vModelRadio, _unref(form).account_type]
                                            ]),
                                            _cache[27] || (_cache[27] = _createElementVNode("label", { for: "q2_5_a1" }, "普通", -1)),
                                            _withDirectives(_createElementVNode("input", {
                                                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event) => ((_unref(form).account_type) = $event)),
                                                value: _unref(AccountType).CURRENT,
                                                class: "visually-hidden",
                                                type: "radio",
                                                name: "q2_5",
                                                id: "q2_5_a2"
                                            }, null, 8, _hoisted_12), [
                                                [_vModelRadio, _unref(form).account_type]
                                            ]),
                                            _cache[28] || (_cache[28] = _createElementVNode("label", { for: "q2_5_a2" }, "当座", -1)),
                                            _cache[29] || (_cache[29] = _createElementVNode("br", null, null, -1)),
                                            ((_f = props.errors) === null || _f === void 0 ? void 0 : _f.account_type)
                                                ? (_openBlock(), _createElementBlock("p", _hoisted_13, _toDisplayString(props.errors.account_type), 1))
                                                : _createCommentVNode("", true),
                                            _cache[30] || (_cache[30] = _createElementVNode("p", { class: "sub_t" }, "口座名義", -1)),
                                            _withDirectives(_createElementVNode("input", {
                                                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event) => ((_unref(form).account_holder) = $event)),
                                                type: "text",
                                                name: "q2_7",
                                                class: "f_corp wmax inquiry-form",
                                                placeholder: "例：ﾔﾏﾀﾞ ﾀﾛｳ"
                                            }, null, 512), [
                                                [_vModelText, _unref(form).account_holder]
                                            ]),
                                            _cache[31] || (_cache[31] = _createElementVNode("span", null, "（半角ｶﾅ）", -1)),
                                            _cache[32] || (_cache[32] = _createElementVNode("br", null, null, -1)),
                                            ((_g = props.errors) === null || _g === void 0 ? void 0 : _g.account_holder)
                                                ? (_openBlock(), _createElementBlock("p", _hoisted_14, _toDisplayString(props.errors.account_holder), 1))
                                                : _createCommentVNode("", true),
                                            _cache[33] || (_cache[33] = _createElementVNode("p", { class: "sub_t" }, "口座番号", -1)),
                                            _withDirectives(_createElementVNode("input", {
                                                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event) => ((_unref(form).account_number) = $event)),
                                                type: "text",
                                                name: "q2_8",
                                                class: "f_corp w40 inquiry-form",
                                                placeholder: "例：0000000",
                                                maxlength: "7"
                                            }, null, 512), [
                                                [_vModelText, _unref(form).account_number]
                                            ]),
                                            _cache[34] || (_cache[34] = _createElementVNode("span", null, "（半角数字7桁）", -1)),
                                            _cache[35] || (_cache[35] = _createElementVNode("br", null, null, -1)),
                                            _cache[36] || (_cache[36] = _createElementVNode("span", null, "6桁の口座をお持ちの方は左に0を追加して7桁でご入力ください。", -1)),
                                            ((_h = props.errors) === null || _h === void 0 ? void 0 : _h.account_number)
                                                ? (_openBlock(), _createElementBlock("p", _hoisted_15, _toDisplayString(props.errors.account_number), 1))
                                                : _createCommentVNode("", true)
                                        ])
                                    ]),
                                    _createElementVNode("div", _hoisted_16, [
                                        _createElementVNode("div", _hoisted_17, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(orderedErrors.value, (error) => {
                                                return (_openBlock(), _createElementBlock("p", null, _toDisplayString(error), 1));
                                            }), 256))
                                        ]),
                                        _cache[39] || (_cache[39] = _createElementVNode("ul", null, [
                                            _createElementVNode("li", null, [
                                                _createElementVNode("button", {
                                                    type: "submit",
                                                    id: "submit-button",
                                                    value: "登録"
                                                }, "登録")
                                            ])
                                        ], -1))
                                    ])
                                ], 32)
                            ])
                        ])
                    ]),
                    _createVNode(footerVue)
                ]),
                (showSuccessModal.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                        _createElementVNode("div", {
                            class: "modal-bg",
                            onClick: onCloseModal
                        }),
                        _createElementVNode("div", { class: "modal-content" }, [
                            _createElementVNode("div", { class: "pop" }, [
                                _createElementVNode("div", { class: "close_bt" }, [
                                    _createElementVNode("img", {
                                        src: "/images/common/i_cross.svg",
                                        onClick: onCloseModal
                                    })
                                ]),
                                _cache[42] || (_cache[42] = _createElementVNode("h2", null, "登録完了", -1)),
                                _cache[43] || (_cache[43] = _createElementVNode("p", { class: "text-center" }, " メンターとして登録完了しました。 ", -1)),
                                _createElementVNode("div", { class: "bt_box" }, [
                                    _createElementVNode("ul", null, [
                                        _createElementVNode("li", null, [
                                            _createElementVNode("button", {
                                                type: "button",
                                                class: "bt_ok",
                                                onClick: onCloseModal
                                            }, "OK")
                                        ])
                                    ])
                                ])
                            ])
                        ])
                    ]))
                    : _createCommentVNode("", true)
            ]));
        };
    }
});
